import { Outlet } from "react-router-dom";

import TopLeftLogo from "components/TopLeftLogo";
import OnboardingStepper from "components/onboarding/OnboardingPage/OnboardingStepper";


export default function OnboardingLayout({ step }: { step?: number }) {
  return (
    <div className="flex flex-col lg:flex-row w-full min-h-full">
      <div className="flex-auto lg:w-[70%]">
        <TopLeftLogo
          content={ <Outlet /> }
          className="lg:min-w-[640px] lg:max-w-[640px] md:min-w-[640px]"
        />
      </div>
      <div className="flex-auto lg:w-[30%] bg-brandLightest dark:bg-primary-50 p-6">
        <OnboardingStepper step={ step || 1 } />
      </div>
    </div>
  );
};
